import { makeAutoObservable, runInAction } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export default class ExpenseCategoryStore {
	constructor() {
		makeAutoObservable(this);
		makePersistable(this, {
			name: 'ExpenseCategoryStore',
			properties: [				
				'expenseCategory',				
			],
		});
	}

	expenseCategory = [];
	
	reset = () => {		
		this.expenseCategory = [];	
	};	

	setExpenseCategory = async data => {
		runInAction(() => {
			this.expenseCategory = data;
		});
	};
}